// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// Values from .env.local environment variables
const firebaseConfig = {
  apiKey: "AIzaSyBhVfWYFqUVCWjyuWltqR1tnqy96GClE6c",
  authDomain: "a6608beb46558342c7b6c0bdd07d.firebaseapp.com",
  databaseURL: "https://a6608beb46558342c7b6c0bdd07d-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "a6608beb46558342c7b6c0bdd07d",
  storageBucket: "a6608beb46558342c7b6c0bdd07d.firebasestorage.app",
  messagingSenderId: "850656483314",
  appId: "1:850656483314:web:495cdd17d28c7dff91fd6b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export { firebaseConfig }; // Export for debugging
export default app;
